import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage.jsx';
import DashboardPage from './pages/DashboardPage';
import RegisterPage from './pages/RegisterPage.jsx';
import EventosPage from './pages/EventosPage';
import EventoDetalhesPage from './pages/EventoDetalhesPage';
import AdminCheckinPage from './pages/AdminCheckinPage';
import AdminInscricoesPage from './pages/admin/AdminInscricoesPage'; // CAMINHO ATUALIZADO
import MeusCertificadosPage from './pages/MeusCertificadosPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import CreateUserPage from './pages/admin/CreateUserPage'; // NOME ATUALIZADO
import AdminUserListPage from './pages/admin/AdminUserListPage'; // NOVO IMPORT
import ProfilePage from './pages/ProfilePage';
import SelfCheckinPage from './pages/SelfCheckinPage'; // NOVO IMPORT
import SupportPage from './pages/SupportPage'; // NOVO IMPORT
import QuickCheckinSignupPage from './pages/QuickCheckinSignupPage'; // NOVO IMPORT

import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Navbar from './components/Navbar';
import Footer from './components/Footer';

import GerenciamentoEventosPage from './pages/admin/GerenciamentoEventosPage';
import GerenciamentoSessoesPage from './pages/admin/GerenciamentoSessoesPage';

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="flex flex-col min-h-screen">
          <AppContent />
        </div>
        <ToastContainer position="bottom-right" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      </AuthProvider>
    </Router>
  );
}

function AppContent() {
  const { isAuthenticated, participanteRole } = useAuth();

  const PrivateRoute = ({ children, requiredRole }) => {
    if (!isAuthenticated) {
      return <Navigate to="/login" />;
    }
    if (requiredRole && participanteRole !== requiredRole) {
      return <Navigate to="/dashboard" />;
    }
    return children;
  };

  return (
    <>
      <Navbar />
      <main className="flex-grow">
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          {/* Rota ajustada para não esperar o token como path parameter */}
          <Route path="/reset-password" element={<ResetPasswordPage />} /> 
          <Route path="/eventos" element={<EventosPage />} />
          <Route path="/eventos/:eventoId" element={<EventoDetalhesPage />} />
          
          {/* ROTA PÚBLICA PARA CADASTRO RÁPIDO */}
          <Route path="/quick-checkin-public" element={<QuickCheckinSignupPage />} />

          <Route
            path="/meus-certificados"
            element={
              <PrivateRoute>
                <MeusCertificadosPage />
              </PrivateRoute>
            }
          />

          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <DashboardPage />
              </PrivateRoute>
            }
          />

          <Route
            path="/profile"
            element={
              <PrivateRoute>
                <ProfilePage />
              </PrivateRoute>
            }
          />

          <Route
            path="/meu-checkin"
            element={
              <PrivateRoute>
                <SelfCheckinPage />
              </PrivateRoute>
            }
          />
          
          <Route
            path="/support"
            element={
              <PrivateRoute>
                <SupportPage /> {/* NOVA ROTA */}
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/checkin"
            element={
              <PrivateRoute requiredRole="ROLE_ADMIN">
                <AdminCheckinPage />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/eventos"
            element={
              <PrivateRoute requiredRole="ROLE_ADMIN">
                <GerenciamentoEventosPage />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/eventos/:eventoId/sessoes"
            element={
              <PrivateRoute requiredRole="ROLE_ADMIN">
                <GerenciamentoSessoesPage />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/inscricoes"
            element={
              <PrivateRoute requiredRole="ROLE_ADMIN">
                <AdminInscricoesPage />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/usuarios"
            element={
              <PrivateRoute requiredRole="ROLE_ADMIN">
                <AdminUserListPage /> {/* NOVA ROTA */}
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/usuarios/criar"
            element={
              <PrivateRoute requiredRole="ROLE_ADMIN">
                <CreateUserPage /> {/* ROTA ATUALIZADA */}
              </PrivateRoute>
            }
          />

          <Route
            path="/"
            element={isAuthenticated ? <Navigate to="/dashboard" /> : <Navigate to="/login" />}
          />

          <Route path="*" element={<div className="container mx-auto p-4">Página não encontrada!</div>} />

        </Routes>
      </main>
      <Footer />
    </>
  );
}

export default App;